import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { postAuthWalletConnect } from "@/modules/auth/api/user/connect-wallet";
import { useUserStore } from "@/modules/auth/store/user";
import { logger } from "@/shared/utils/logger";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { useCallback, useState } from "react";
import { useAccount, useChainId } from "wagmi";

type Props = {
  onTON: () => void;
  onEVM: () => void;
  onClose: () => void;
};

const SelectWallet = ({ onTON, onEVM, onClose }: Props) => {
  const { setUserOnly } = useUserStore();
  const [baseChoosen, setBaseChosen] = useState(false);
  const chainId = useChainId();
  const { openConnectModal } = useConnectModal();
  const { address, isConnected } = useAccount();
  const [isLoading, setIsLoading] = useState(false);

  const linkWallet = useCallback(async () => {
    if (!address) return;

    try {
      setIsLoading(true);
      const res = await postAuthWalletConnect({
        wallet: address,
        network: "EVM",
        chainId: chainId.toString(),
      });

      if (!res) return;

      setUserOnly();
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
      onEVM();
    }
  }, [address, chainId, onEVM, setUserOnly]);

  const handleClick = async () => {
    if (!isConnected) {
      openConnectModal?.();
    } else {
      await linkWallet();
    }
  };

  return (
    <Modal title={""} onClose={onClose}>
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {!baseChoosen
              ? "Select wallet to connect"
              : "Connect your BASE wallet"}
          </p>
        </div>

        {!baseChoosen ? (
          <div className="w-full flex items-center gap-4">
            <Button
              onClick={onTON}
              text="TON"
              size="large"
              mode="bezeled"
              className="w-full"
            />

            <Button
              onClick={() => {
                setBaseChosen(true);
                handleClick();
              }}
              text="BASE"
              size="large"
              className="w-full"
            />
          </div>
        ) : (
          <div className="w-full flex items-center gap-4">
            <Button
              onClick={handleClick}
              text={
                isConnected
                  ? "Continue and confirm in your wallet app"
                  : "Connect with wallet"
              }
              disabled={isLoading}
              loading={isLoading}
              className="w-full"
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SelectWallet;
